import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import uuid from 'uuid';
import { Body2 } from 'ensightful-koala-ui';

import { Subtitle1, H3 } from 'components/atoms/Text';
import { CourseSetUpContainer, UploadCSV } from 'components/organisms/CourseSetUp';
import GroupCards from './GroupCards';

const HeaderContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    flex-wrap: wrap;
`;

const UploadCSVButtonContainer = styled.div`
    display: ${(props) => (props.review ? 'none' : 'flex')};
    justify-content: center;
`;

const StudentListContainer = styled.div`
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

const UnassignedStudentsContainer = styled.div`
    margin-top: 1.5em;
    border-top: 1px solid #e0e0e0;
    padding-top: 1.5em;
`;

const StyledUnassignedStudentList = styled(Body2)`
    color: #757575;
`;

const ScrollContainer = styled.div`
    overflow-y: auto;
    width: 100%;
    height: 100%;
`;

const ExternalCSVOptions = ({ fieldKeys, courseData = {}, review = false, handleInputChange }) => {
    const [teamList, setTeamList] = useState([]);
    const unassignedStudentsList = courseData[fieldKeys.STUDENT_LIST]?.filter((student) => !student.group) || [];

    const renderUnassignedStudentsList = () => {
        return unassignedStudentsList.map((student, index) => {
            if (!student) return '';
            return `${
                student?.name ||
                student?.email ||
                student?.display_name ||
                student?.first_name ||
                student?.username ||
                ''
            }${index < unassignedStudentsList?.length - 1 ? ',' : ''} `;
        });
    };

    const teamListGenerator = () => {
        const currentStudentList = courseData[fieldKeys.STUDENT_LIST] || [];
        const reducedTeamList = currentStudentList.reduce((studentList, student) => {
            if (student?.group in studentList) {
                studentList[student.group] = [...studentList[student.group], student];
            } else if (student?.group) {
                studentList[student.group] = [student];
            }
            return studentList;
        }, {});
        let newTeamList = [];
        Object.entries(reducedTeamList).forEach(([key, value], index) => {
            if (key) {
                newTeamList = [
                    ...newTeamList,
                    { id: uuid.v4(), name: value.name || `Team ${index + 1}`, members: value },
                ];
            }
        });
        setTeamList(newTeamList);
    };

    useEffect(() => {
        teamListGenerator();
    }, [courseData]);

    return (
        <CourseSetUpContainer>
            <HeaderContainer review={review}>
                <H3>External CSV Team Set-up</H3>
                <UploadCSVButtonContainer review={review}>
                    <UploadCSV
                        onRequest={(data) => handleInputChange(fieldKeys?.STUDENT_LIST, data)}
                        userData={courseData[fieldKeys?.STUDENT_LIST]}
                        option={'icon-button'}
                    />
                </UploadCSVButtonContainer>
            </HeaderContainer>
            <ScrollContainer>
                <UnassignedStudentsContainer>
                    <Subtitle1>Unassigned Students ({unassignedStudentsList?.length})</Subtitle1>
                    <StyledUnassignedStudentList>{renderUnassignedStudentsList()}</StyledUnassignedStudentList>
                </UnassignedStudentsContainer>

                <StudentListContainer>
                    <GroupCards teamList={teamList} editOption={false} />
                </StudentListContainer>
            </ScrollContainer>
        </CourseSetUpContainer>
    );
};

export default ExternalCSVOptions;
